import { AdminSidebar } from "./AdminSidebar";
import { SidebarInset, useSidebar } from "@/components/ui/sidebar";
import { ReactElement, Suspense } from "react";
import AdminHeader from "./AdminHeader";
import { Navigate, useLoaderData } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
import LoadingAnimation from "../components/ui/LoadingAnimation";
import { Toaster } from "@/components/ui/sonner";

export const HEADER_HEIGHT = 64;
export const MAIN_MARGIN = 24;
const SIDEBAR_WIDTH = 272;

export const BODY_OUTER = HEADER_HEIGHT + MAIN_MARGIN - 8.5 * 2;

export default function AdminLayout({ children }: { children: ReactElement }) {
    const isAuth = useLoaderData();

    const isMobile = useIsMobile();

    if (!isAuth) {
        return <Navigate to={"/login"} />;
    }

    const { open } = useSidebar();
    return (
        <>
            <AdminSidebar sidebarWidth={SIDEBAR_WIDTH} />
            <SidebarInset className="z-50 border-l border-primary">
                <Toaster
                    closeButton
                    richColors
                    theme="light"
                    position="top-center"
                />

                <AdminHeader />
                <div
                    style={{
                        height: `calc(100vh - ${HEADER_HEIGHT}px -  ${8.5 * 2}px)`,
                        width: open
                            ? isMobile
                                ? `calc(100vw  - ${MAIN_MARGIN * 2}px)`
                                : `calc(100vw - ${SIDEBAR_WIDTH}px - ${MAIN_MARGIN * 2}px)`
                            : `calc(100vw  - ${MAIN_MARGIN * 2}px)`,
                        marginLeft: MAIN_MARGIN,
                        marginRight: MAIN_MARGIN,
                    }}
                    className="relative gap-3 overflow-auto overflow-x-clip"
                >
                    <Suspense
                        fallback={
                            <div className="h-screen w-full">
                                <LoadingAnimation />
                            </div>
                        }
                    >
                        {children}
                    </Suspense>
                </div>
            </SidebarInset>
        </>
    );
}
